<template>
  <div v-if="isShow" class="d3-flash">
  </div>
</template>

<style lang="scss" scoped>
  @import "../../global-variables";

  .d3-flash {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 100000;
    opacity: 0;
    background: #FFF;
    animation-duration: 1.5s;
    animation-name: flash;
  }

  @keyframes flash {
    0% {
      opacity: 0;
    }
    5% {
      opacity: 1;
    }
    60% {
      opacity: 1;
    }
    98% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
</style>

<script>
  export default{
    data(){
      return {
        isShow: false
      };
    },

    methods: {
      show(){
        this.isShow = true;

        setTimeout(()=>{
          this.isShow = false;
        }, 1500);
      }
    },

    created(){
      this.$root.$on('show-flash', this.show);
    },

    beforeDestroy(){
      this.$root.$off('show-loading', this.show);
    }
  };
</script>



// WEBPACK FOOTER //
// Flash.vue?5762cbfd